"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightLoader = void 0;
const THREE = __importStar(require("three"));
const viewer_rendering_engine_light_engine_1 = require("@shapediver/viewer.rendering-engine.light-engine");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const tsyringe_1 = require("tsyringe");
class LightLoader {
    // #region Constructors (1)
    constructor(_renderingEngine) {
        this._renderingEngine = _renderingEngine;
        this._converter = tsyringe_1.container.resolve(viewer_shared_services_1.Converter);
        this._shadowMapCount = 0;
        this._forceDisabledShadows = false;
    }
    // #endregion Constructors (1)
    // #region Public Methods (2)
    init() { }
    load(light, dataChild) {
        let threeLight = dataChild.children[0] instanceof THREE.Light ? dataChild.children[0] : null;
        if (light instanceof viewer_rendering_engine_light_engine_1.AmbientLight) {
            if (!threeLight) {
                threeLight = new THREE.AmbientLight();
                dataChild.add(threeLight);
            }
            const threeAmbientLight = threeLight;
            threeAmbientLight.color = new THREE.Color(this._converter.toThreeJsColorInput(light.color));
            threeAmbientLight.intensity = light.intensity;
        }
        if (light instanceof viewer_rendering_engine_light_engine_1.DirectionalLight) {
            if (!threeLight) {
                threeLight = new THREE.DirectionalLight();
                dataChild.add(threeLight);
                dataChild.add(threeLight.target);
            }
            const threeDirectionalLight = threeLight;
            threeDirectionalLight.color = new THREE.Color(this._converter.toThreeJsColorInput(light.color));
            threeDirectionalLight.intensity = light.intensity;
            if (light.useNodeData) {
                threeDirectionalLight.position.set(0, 0, 0);
                threeDirectionalLight.target.position.set(0, 0, -1);
            }
        }
        if (light instanceof viewer_rendering_engine_light_engine_1.HemisphereLight) {
            if (!threeLight) {
                threeLight = new THREE.HemisphereLight();
                dataChild.add(threeLight);
            }
            const threeHemisphereLight = threeLight;
            threeHemisphereLight.color = new THREE.Color(this._converter.toThreeJsColorInput(light.color));
            threeHemisphereLight.intensity = light.intensity;
            threeHemisphereLight.groundColor = new THREE.Color(this._converter.toThreeJsColorInput(light.groundColor));
        }
        if (light instanceof viewer_rendering_engine_light_engine_1.PointLight) {
            if (!threeLight) {
                threeLight = new THREE.PointLight();
                dataChild.add(threeLight);
            }
            const threePointLight = threeLight;
            threePointLight.color = new THREE.Color(this._converter.toThreeJsColorInput(light.color));
            threePointLight.intensity = light.intensity;
            threePointLight.distance = light.distance;
            threePointLight.decay = light.decay;
            threePointLight.position.set(light.position[0], light.position[1], light.position[2]);
        }
        if (light instanceof viewer_rendering_engine_light_engine_1.SpotLight) {
            if (!threeLight) {
                threeLight = new THREE.SpotLight(new THREE.Color(this._converter.toThreeJsColorInput(light.color)), light.intensity, light.distance, light.angle, light.penumbra, light.decay);
                dataChild.add(threeLight);
                dataChild.add(threeLight.target);
            }
            const threeSpotLight = threeLight;
            threeSpotLight.color = new THREE.Color(this._converter.toThreeJsColorInput(light.color));
            threeSpotLight.intensity = light.intensity;
            threeSpotLight.distance = light.distance;
            threeSpotLight.angle = light.angle;
            threeSpotLight.penumbra = light.penumbra;
            threeSpotLight.decay = light.decay;
            threeSpotLight.position.set(light.position[0], light.position[1], light.position[2]);
            threeSpotLight.target.position.set(light.target[0], light.target[1], light.target[2]);
        }
    }
    adjustToBoundingBox(light, dataChild, boundingBox) {
        let threeLight = dataChild.children[0];
        if (light instanceof viewer_rendering_engine_light_engine_1.DirectionalLight) {
            const threeDirectionalLight = threeLight;
            const bs = boundingBox.boundingSphere;
            threeDirectionalLight.position.set(bs.center[0] + light.direction[0] * bs.radius * 2.35, bs.center[1] + light.direction[1] * bs.radius * 2.35, bs.center[2] + light.direction[2] * bs.radius * 2.35);
            threeDirectionalLight.target.position.set(bs.center[0], bs.center[1], bs.center[2]);
            if (light.castShadow === true && this.forceDisabledShadows === false) {
                threeDirectionalLight.castShadow = true;
                threeDirectionalLight.shadow.camera.up.set(0, 0, 1);
                threeDirectionalLight.shadow.camera.far = 8 * bs.radius;
                threeDirectionalLight.shadow.camera.right = 1.5 * bs.radius;
                threeDirectionalLight.shadow.camera.left = -1.5 * bs.radius;
                threeDirectionalLight.shadow.camera.top = 1.5 * bs.radius;
                threeDirectionalLight.shadow.camera.bottom = -1.5 * bs.radius;
                threeDirectionalLight.shadow.mapSize.width = light.shadowMapResolution;
                threeDirectionalLight.shadow.mapSize.height = light.shadowMapResolution;
                threeDirectionalLight.shadow.bias = light.shadowMapBias;
                threeDirectionalLight.shadow.camera.updateProjectionMatrix();
                this._shadowMapCount++;
            }
            else {
                threeDirectionalLight.castShadow = false;
            }
        }
    }
    get shadowMapCount() {
        return this._shadowMapCount;
    }
    set shadowMapCount(value) {
        this._shadowMapCount = value;
    }
    get forceDisabledShadows() {
        return this._forceDisabledShadows;
    }
    set forceDisabledShadows(value) {
        this._forceDisabledShadows = value;
    }
}
exports.LightLoader = LightLoader;
//# sourceMappingURL=LightLoader.js.map